<div class="comment__input fs__sm">
  <input type="text" appAutofocus placeholder="Send..." [formControl]="control" required (keyup.enter)="clicked.emit()" />
  <fa-icon [icon]="faSend" class="primary" [class.disabled]="!control.valid" (click)="clicked.emit()"></fa-icon>
</div>
